<template>
  <div class="add-address">
    <form @submit.stop.prevent="handleAddress">
      <b-row>
        <div class="form-group col-12" v-if="!isProfile">
          <label for="reference" v-translate>Reference Name</label>
          <b-form-input id="reference" name="reference" v-model="theAddress.reference" class="col-12" />
        </div>
        <div class="form-group col-sm-7">
          <label for="from_extra" v-translate>Street and number</label>
          <div class="input-group">
            <address-autocomplete ref="addressAutocomplete" @selected="checkToPlace" :minCharacter="4" />
          </div>
          <small class="form-text text-muted" v-translate>We use Google to validate all addresses, please keep it in mind when you enter yours.</small>
        </div>
        <div class="form-group col-sm-5">
          <label for="from_extra" v-translate>Floor, door, etc.</label>
          <div class="input-group">
            <b-form-input id="from_extra" name="from_extra" v-model="theAddress.address_extra" class="col-12" />
          </div>
        </div>
        <div class="form-group col-sm-12" v-if="!isProfile">
          <label for="from_contact" v-translate>Contact Name</label>
          <div class="input-group">
            <b-form-input id="from_contact" name="from_contact" v-model="theAddress.contact" required />
          </div>
        </div>
        <div class="form-group col-sm-6" v-if="!isProfile">
          <label for="from_email" v-translate>Contact E-mail</label>
          <div class="input-group">
            <b-form-input trim id="from_email" name="from_email" v-model="theAddress.email" required />
          </div>
        </div>
        <div class="form-group col-sm-6" v-if="!isProfile">
          <label for="from_phone" v-translate>Contact Phone</label>
          <div class="input-group">
            <cleave :options="{ phone: true, phoneRegionCode: this.$cookies.get('country').toLowerCase() }" class="form-control" v-model="theAddress.phone" autocomplete="nope" required></cleave>
          </div>
        </div>
        <div class="text-right form-group col-12 form-actions">
          <b-button type="submit" variant="primary" size="lg" v-translate>Submit address</b-button>
          <b-button type="button" variant="outline-primary" size="lg" @click.prevent="emitCancel" v-translate>Cancel</b-button>
        </div>
      </b-row>
    </form>
    <b-modal size="lg" id="modalPickPlace" ref="modalPickPlace" hide-footer hide-header @hide="$refs.pickPlaceMap.pickPlace(0, 0)">
      <place-picker ref="pickPlaceMap" @cancel="closeModalPickPlace" @placePicked="setPlacePicked" centerMap fit-always :zoom="17" />
    </b-modal>
  </div>
</template>
<script>
import AddressMixins from '@/mixins/address.mixin.js'
import AddressAutocomplete from '@/components/AddressAutocomplete'
import vueAuthInstance from '@/services/auth'
import Cleave from 'vue-cleave'
import PlacePicker from '@/components/PlacePicker'
import { ADDRESS_CREATE, UPDATE_USER } from '@/store/actions.type'

export default {
  name: 'AddAddress',
  components: {
    AddressAutocomplete,
    Cleave,
    PlacePicker
  },
  data() {
    return {
      theAddress: {
        reference: null,
        contact: this.$store.getters.profile && this.isProfile ? this.$store.getters.profile.name : null,
        email: this.$store.getters.profile && this.isProfile ? this.$store.getters.profile.email : null,
        phone: this.$store.getters.profile && this.isProfile ? this.$store.getters.profile.phone : null,
        place_id: null,
        address_extra: null,
        favourite: false
      },
      ignoreArea: false
    }
  },
  computed: {
    authHeaders() {
      return {
        Authorization: 'Bearer ' + vueAuthInstance.getToken()
      }
    }
  },
  props: {
    isProfile: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  mixins: [AddressMixins],
  mounted() {
    if (this.isProfile) {
      this.setProfileData()
      this.ignoreArea = true
    }
  },
  methods: {
    setProfileData() {
      setTimeout(function () {
        this.theAddress.reference = 'Profile'
        this.theAddress.contact = this.$store.getters.profile ? this.$store.getters.profile.name : null
        this.theAddress.email = this.$store.getters.profile ? this.$store.getters.profile.email : null
        this.theAddress.phone = this.$store.getters.profile ? this.$store.getters.profile.phone : null

        if (this.theAddress.contact === null || this.theAddress.email === null || this.theAddress.phone === null) {
          this.setProfileData()
        }
      }.bind(this), 100)
    },
    handleAddress(evt) {
      evt.preventDefault()
      if (!this.theAddress.place_id) {
        alert('Please enter the address')
      } else {
        this.handleAddressSubmit()
      }
    },
    handleAddressSubmit() {
      if (!this.theAddress.reference) {
        this.theAddress.reference = this.theAddress.contact
      }
      this.$store.dispatch(ADDRESS_CREATE, this.theAddress)
        .then(response => {
          if (response.ok) {
            response.json().then(json => {
              this.theAddress = {
                reference: null,
                place_id: null,
                address_extra: null,
                favourite: false
              }
              // this.$refs.autocomplete_from.clear()
              if (this.isProfile) {
                this.$store.dispatch(UPDATE_USER, { profile_address_id: json.id })
                  .then(response => {
                    this.emitSuccess()
                  })
              } else {
                this.emitSuccess()
              }
            })
          }
        }, error => {
          const obj = {
            title: 'ERROR',
            message: error.body.message,
            type: 'error',
            customCloseBtnText: this.$gettext('Close')
          }
          this.$root.$children[0].$refs.simplert.openSimplert(obj)
        })
    },
    autocompleteEndpoint(query) {
      if (query.length >= 3) {
        return this.$appConfig.api.baseUrl + 'autocomplete?query=' + query
      }
    },
    async checkToPlace(place) {
      await this.checkPlace(place)
      this.$nextTick(() => {
        if (this.theCheckedAddress.id) {
          this.theAddress.place_id = this.theCheckedAddress.id
          this.theCheckedAddress = {}
        } else if (this.theCheckedAddress.validAddress === false) {
          this.$refs.modalPickPlace.show()
          setTimeout(function () {
            this.$refs.pickPlaceMap.center = {
              lat: this.theCheckedAddress.lat,
              lng: this.theCheckedAddress.lng
            }
            this.$refs.pickPlaceMap.styles = 'height: 500px;'
          }.bind(this), 100)
        }
      })
    },
    setPlacePicked(place) {
      this.theAddress.place_id = place.id
      this.$refs.modalPickPlace.hide()
    },
    closeModalPickPlace() {
      this.$refs.modalPickPlace.hide()
    },
    formattedDisplay(result) {
      return result.main_text + ', ' + result.secondary_text
    },
    emitCancel() {
      this.$emit('cancel')
    },
    emitSuccess() {
      this.$emit('success')
    }
  }
}
</script>
